import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PopUpNotificationService } from "@core/services/popup-notification.service";
import * as LandingAction from "@modules/landing/store/actions/landing.action";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { TranslateService } from "@ngx-translate/core";
import { catchError, mergeMap } from "rxjs/operators";
import { LandingService } from "../../services/landing.service";

@Injectable()
export class LandingEffect {
  constructor(
    private actions$: Actions,
    private landingService: LandingService,
    private popupService: PopUpNotificationService,
    private translate: TranslateService
  ) {}

  advanceOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LandingAction.sendLead),
      mergeMap((p) => {
        return this.landingService.sendLead(p).pipe(
          mergeMap(() => {
            this.popupService.success({message: this.translate.instant('LANDING.SENT_FORM_SUCCESFULLY')})
            return [LandingAction.eraseData()];
          }),
          catchError((httpError: HttpErrorResponse) => {
            const { status, error } = httpError;
            console.error({ status, error });
            this.popupService.error(error);
            return [];
          })
        );
      })
    )
  );
}
